module.exports = __webpack_public_path__ + "img/fast-start-incentive.6ad3212.webp";